export interface ILookupData {
  Mnemonic_Id: number;
  Mnemonic: string;
  Result: number;

  D1_Date?: any;
  D1_Numeric?: number;
  D1_Text?: string;
  D2_Date?: any;
  D2_Numeric?: number;
  D2_Text?: string;
  D3_Date?: any;
  D3_Numeric?: number;
  D3_Text?: string;
  Id?: number;
  ScenarioNum?: number;
}

export class LookupData implements ILookupData {
  D1_Date?: any;
  D1_Numeric?: number;
  D1_Text?: string;
  D2_Date?: any;
  D2_Numeric?: number;
  D2_Text?: string;
  D3_Date?: any;
  D3_Numeric?: number;
  D3_Text?: string;
  Id?: number;
  ScenarioNum?: number;
  toBeDeleted?: boolean;

  constructor(public Mnemonic: string = null, public Mnemonic_Id: number = null, public Result: number = null) {
    this.Id = Mnemonic_Id;
    this.ScenarioNum = -1;
  }
}

export interface PreviousData {
  value?: string;
  dimension?: 'rows' | 'cols' | 'pivots' | 'results';
  index?: number[];
}

/**
 * A <**SpreadLookupInfo**> object is the aggregation of all the <**LookupData**> objects
 * for the same combination `mnemonic`+`thirdDimension`
 */
export class SpreadLookupInfo {
  startRow: number;
  startCol: number;
  endRow: number;
  endCol: number;
  mnemonic: string;
  id: number;

  rows: string[];
  numberOfRows: number;
  cols: string[];
  numberOfColumns: number;
  dimMnemonics: string[];

  thirdDimension: string;
  allThirdDimensions?: any[];
  references: string[];
  results: number[][];
  category: string;
  previousData?: PreviousData;
  toBeDeleted?: boolean;
  toBeDeletedRows: number[];
  toBeDeletedCols: number[];

  // static addRow(value: any) {
  //   this.cols.push(value);
  //   this.numberOfColumns = this.cols.length;
  // }
}
